export default __webpack_public_path__ + "static/media/UserGuide_ko_KR.090bfe0d.pdf";